var MODULE = (function (library, $) {

    $(function () {
        $(".j-voucher-button").on('click', function (event) {
            event.preventDefault();

            var token = $("input[name='_csrf']").val();
            var header = "X-CSRF-TOKEN";

            var voucherButton = $(this);
            $(".voucher-wait").removeClass("hidden");
            $(".voucher-add").addClass("hidden");

            $(".voucher-error").remove();

            $.ajax({
                url: "/checkout/redeem-voucher",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify({voucherCode: $('#voucherInput').val()}),
                beforeSend: function (xhr) {
                    xhr.setRequestHeader(header, token);
                }
            }).done(function () {
                location.reload(true);
            }).fail(function (response) {
                $(".voucher-wait").addClass("hidden");
                $(".voucher-add").removeClass("hidden");

                if (!response.hasOwnProperty("responseText")) {
                    return;
                }

                var errorMessageDiv = $("<div>").addClass("voucher-error text-danger").html(response.responseText);
                voucherButton.closest(".voucher-section").parent().append(errorMessageDiv)
            });
        });

        $(".j-voucher-remove").on('click', function (event) {
            event.preventDefault();

            var voucherCode = $(this).data("voucher-code");
            var token = $("input[name='_csrf']").val();
            var header = "X-CSRF-TOKEN";

            $.ajax({
                url: "/checkout/release-voucher/" + voucherCode + "/delete",
                type: "POST",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader(header, token);
                }
            }).done(function () {
                location.reload(true);
            });
        });
    });

}(MODULE || {}, jQuery));

$(document).ready(function () {
    if ($(".toggleVoucherButton").css('display') != 'none') {
        var h = $('.at4m-dock-toggle').height();
        $(".mySmartLayout").css('button', h);
        $(".toggleVoucherButton").css('button', h);

        $(".toggleVoucherButton").on('click', function () {
            if ($(".mySmartLayout").css('display') == 'none') {
                $(".toggleVoucherButton").hide();
                $(".mySmartLayout").fadeIn("slow");
            } else {
                $(".mySmartLayout").fadeOut("slow");
            }
        });
    }
});